import * as React from 'react';
import './index.scss';
import HourRank from '@hooks/web/public/hourRank.tsx';
import RichRank from '@hooks/web/public/richRank.tsx';
import GameRank from '@hooks/web/public/gameRank.tsx';
const { useEffect } = React;

interface Props {
  iStage: number,
  iArea: number,
}

const Final: React.FC<Props> = props => {
  useEffect(() => {
  }, [])
  return (
    <div
      className='final'
    >
      <GameRank iStage={props.iStage} iArea={props.iArea} ></GameRank>
      <HourRank iStage={props.iStage} iArea={props.iArea} />
      <RichRank />
    </div>
  )
}

export default Final;